module.exports = __webpack_public_path__ + "static/zgrade-0153f81068cea69d7a1a867b31291fc5.png";